import {
  Dialog,
  DialogBody,
  DialogHeader,
  Typography,
} from "@material-tailwind/react";

import { IoCloseCircle } from "react-icons/io5";
import { useMutation } from "react-query";
import ApiRoutes from "../../services/apiRoutes";
import { handleErrorMessage } from "../../utility";
import OtpInput from "react-otp-input";
import { useState } from "react";
import { apiDirect } from "../../services/apiService";
import { TransactionQueryParams } from "../../models/wallet/transactionQueryParams";
import { useTransferStore } from "../../store/wallet/transferStore";
import AuthService from "../../services/authService";
import { toast } from "react-toastify";
import ClickBaseButton from "../common/buttons/ClickBaseButton";

function EnterTransferPin({
  open: openDialog,
  handleOpen,
  walletId,
}: {
  open: boolean;
  handleOpen: () => void;
  walletId: string;
}) {
  const { accountNumber, selectedBank, transferAmount } = useTransferStore();

  const transferMutation = useMutation(
    " transfer",
    (data: TransactionQueryParams) => {
      const url = `${ApiRoutes.walletTransfer}?Amount=${data.Amount}&BankCode=${data.BankCode}&WalletId=${data.WalletId}&Description=${data.Description}&Email=${data.Email}&AccountNumber=${data.AccountNumber}&Pin=${data.Pin}`;
      return apiDirect.post(url);
    },
    {
      onSuccess(data) {
        setOtp("");
        console.log(data);
        handleOpen();
        toast.success("Transaction successful");
      },
      onError(error: { statusMessage: string }) {
        setOtp("");
        console.log(error);
        handleOpen();
        handleErrorMessage(
          error.statusMessage,
          "unable to complete transaction"
        );
      },
    }
  );

  const [otp, setOtp] = useState("");
  const onOtpChanged = (pin: string) => {
    setOtp(pin);
    console.log(pin);
    console.log(otp.length);
    if (transferMutation.isLoading) return;
    if (otp.length !== 3) return;

    const email = AuthService.user?.data.email;
    const transferObject: TransactionQueryParams = {
      AccountNumber: accountNumber,
      Amount: transferAmount,
      BankCode: selectedBank,
      Description: "Transaction",
      Email: email!,
      Pin: pin,
      Reference: "Ref",
      WalletId: walletId,
    };

    transferMutation.mutate(transferObject);
  };

  return (
    <Dialog
      placeholder={undefined}
      open={openDialog}
      handler={handleOpen}
      size="md"
    >
      <DialogHeader placeholder={undefined} className="block">
        <section className="flex justify-center">
          <Typography
            placeholder={undefined}
            className="font-semibold text-md mx-auto"
          >
            Transaction PIN
          </Typography>
          <IoCloseCircle onClick={() => handleOpen()} />
        </section>
        <Typography
          placeholder={undefined}
          className=" text-lg font-medium text-center pt-4"
        >
          Input your transaction PIN{" "}
        </Typography>
      </DialogHeader>

      <DialogBody
        placeholder={undefined}
        className="justify-center items-center text-center"
      >
        <OtpInput
          containerStyle={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          value={otp}
          onChange={onOtpChanged}
          numInputs={4}
          inputStyle={{
            margin: "16px",
            backgroundColor: "#f3f4f6",
            padding: "16px",
            width: "40px",
            height: "40px",
          }}
          renderInput={(props) => <input {...props} />}
        />
      </DialogBody>
      <ClickBaseButton
        isLoading={transferMutation.isLoading}
        onClick={() => {}}
        className="my-10 md:w-1/5 w-min mx-auto"
      >
        Submit
      </ClickBaseButton>
    </Dialog>
  );
}

export default EnterTransferPin;
